module.exports = __webpack_public_path__ + "static/img/799b590.png";


//////////////////
// WEBPACK FOOTER
// ./src/page/lhsx/0.png
// module id = 604
// module chunks = 2